<div class="mtm-toaster">
  @for (notification of notifications; track notification._toastKey) {
    <notification-view
      [isNotificationProject]="false"
      [duration]="4000"
      [notification]="notification"
      [mode]="NotificationViewType.Toast"
      [showCloseButton]="true"
      (notificationFinish)="removeNotification($event)"></notification-view>
  }
</div>
